import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { AditivosForm } from "../../modais"
import Layout from "../../Layout"
class ContratosCreateForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/contratos")
  }
  render() {
    return (
      <Layout tabActive="Contratos">
        <AditivosForm callBackAditivos={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(ContratosCreateForm)



// WEBPACK FOOTER //
// ./src/views/contratos/aditivos/AditivosCreateForm.js